/**
 * Custom TechQuote mark — isometric cube + Q notch.
 * Geometric, monochrome (uses currentColor).
 */
export default function Logo({ size = 28, className = "" }) {
  return (
    <svg
      viewBox="0 0 40 40"
      width={size}
      height={size}
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="tq-g" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#2563EB" />
          <stop offset="1" stopColor="#1D4ED8" />
        </linearGradient>
      </defs>
      <rect x="1.5" y="1.5" width="37" height="37" rx="8" fill="url(#tq-g)" />
      {/* TQ isometric glyph */}
      <g
        stroke="#FFFFFF"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      >
        {/* T */}
        <path d="M11 13h10" />
        <path d="M16 13v13" />
        {/* Q notch — isometric square bottom right */}
        <path d="M23 20.5h6.5v6.5H23z" />
        <path d="M27.5 24.5l2.5 2.5" />
      </g>
    </svg>
  );
}
